export interface OrderItemStatus {
  statusId: number;
  statusCode: string;
  statusDesc: string;
}
